

import { RequestDetailEdit } from '../../../models/requestDetailEdit';


export class ShipmentDetailEditController implements ng.IController {
    static $inject = ['$mdMedia'];

    constructor(private _$mdMedia: angular.material.IMedia) {

    }

    requestDetailEdit: RequestDetailEdit;
    isShipmentLocationLoading: boolean;
    isShipmentShippingInfoLoading: boolean;
    isShipmentLocationFormValid: boolean;
    isShipmentShippingInfoFormValid : boolean;
    shipmentDetailEditForm: ng.IFormController;

    $onInit() { }

    shipmentNotUndefined(): boolean {
        if (this.requestDetailEdit !== undefined) {
            if (this.requestDetailEdit.requestDetail !== undefined) {
                if (this.requestDetailEdit.requestDetail.requestShipment !== undefined) {
                    return true;
                }
            }
        }
        return false;
       
    }

    get isLoading(): boolean {
        return this.isShipmentLocationLoading || this.isShipmentShippingInfoLoading;
    }

    set isLoading(val: boolean) { }

    get isValid(): boolean {
        return this.isShipmentLocationFormValid && this.isShipmentShippingInfoFormValid &&
            (this.shipmentDetailEditForm ? this.shipmentDetailEditForm.$valid : false);
    }
    set isValid(val: boolean) { }

    get isSubScrollContainer(): boolean {
        return this._$mdMedia('gt-md');
    }

    get isScrollContainer(): boolean {
        return this._$mdMedia('sm') || this._$mdMedia('md');
    }

    isGeneralLedgerRequired(locationCode: string): boolean {
        return locationCode === "Mail Center Darwin Building #42"
            && (this.requestDetailEdit.requestDetail.requestShipment.costCenter == undefined
                || this.requestDetailEdit.requestDetail.requestShipment.costCenter == null
                || this.requestDetailEdit.requestDetail.requestShipment.costCenter == '');
    }
    
    isCostCenterRequired(locationCode: string): boolean {
        if (!this.shipmentNotUndefined()) {
            return false;
        }
        return (locationCode === "Mail Center Darwin Building #42"            
            &&(this.requestDetailEdit.requestDetail.requestShipment.generalLedger == undefined
            || this.requestDetailEdit.requestDetail.requestShipment.generalLedger == null
            || this.requestDetailEdit.requestDetail.requestShipment.generalLedger == ''))
            || this.requestDetailEdit.requestDetail.requestShipment.isAsset;
    }

    isShippingLocationMailCenter(locationCode: string): boolean {
        if (this.requestDetailEdit == undefined || this.requestDetailEdit == null) {
            return locationCode === "Mail Center Darwin Building #42";
        }
        else {
            return locationCode === "Mail Center Darwin Building #42"
                && ((this.requestDetailEdit.requestDetail.requestShipment.generalLedger == undefined
                    || this.requestDetailEdit.requestDetail.requestShipment.generalLedger == null
                    || this.requestDetailEdit.requestDetail.requestShipment.generalLedger == '')
                    || (this.requestDetailEdit.requestDetail.requestShipment.costCenter == undefined
                        || this.requestDetailEdit.requestDetail.requestShipment.costCenter == null
                        || this.requestDetailEdit.requestDetail.requestShipment.costCenter == ''));
        }
    }
   

}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/shipmentDetailEdit/controllers/shipmentDetailEditController.ts
 **/